<script setup lang="ts">
onLaunch(() => {
  console.log('App Launch')
})
onShow(() => {
  console.log('App Show')
})
onHide(() => {
  console.log('App Hide')
})
</script>

<style lang="scss">
@import './static/css/common';
@import './static/css/doc';
page {
  font-family:
    PingFang SC,
    serif;
  font-size: 26rpx;
  color: #555555;
  background: #f3f6fa;
}
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}
.popup-title {
  padding: 24rpx 32rpx 32rpx;
  font-size: 36rpx;
  font-weight: 500;
  color: #242424;
  text-align: center;
}
.popup-close {
  position: absolute;
  top: 32rpx;
  right: 32rpx;
}
.popup-content {
  position: relative;
}
</style>
